import { useQuery } from '@tanstack/react-query';
import { API } from '~/shared/API/api';
import { useEffect } from 'react';
import { useUserStore } from '~/shared/store/userStore';

export const useGetCurrentUser = () => {
  const { setUser } = useUserStore((state) => state.actions);
  const { data, isLoading, isSuccess } = useQuery({
    queryKey: ['user'],
    queryFn: () => API.getCurrentUser(),
    retry: 1,
    select: (data) => data.data,
  });

  const user = data?.payload || null;
  const success = data?.payload.is_active || false;

  useEffect(() => {
    if (isSuccess && user) {
      setUser(user);
    }
  }, [isSuccess, user, setUser]);

  return { user, success, data, isLoading, isSuccess };
};
